module.exports = __webpack_public_path__ + "img/1_008.8b026097.jpg";